export default __webpack_public_path__ + "static/media/logo.125b4550.png";